import React from 'react';
import { render } from 'react-dom';
import elementClosest from 'element-closest';
import { MessagePropertiesProvider } from '../../contexts/messageProperties';
import SearchApp from './header/search/searchApp';
import initMiniCart from './header/miniCart';
import initMiniAccount from './header/miniAccount';
import initMiniFavourites from './header/miniFavourites';
import initNavigationEvents from './header/navigation';
import ScrollToTop from '../../components/scrollToTop/scrollToTop';
import mediaQuery from '../../helpers/mediaQuery';
import cleanUpCheckoutStorageData from '../../helpers/cleanUpCheckoutStorageData';
import { addToCartFormHandler } from '../../helpers/addToCartHandler';
import { trackListView } from '../../analytics';
import '../../../../pcss/global_app.pcss';
import cleanUpFinanceCalculatorStorageData from '../../helpers/cleanUpFinanceCalculatorStorageData';

if (window.bbGlobal.category.type) {
  trackListView();
}

if (module.hot) {
  module.hot.accept();
}

elementClosest(window);

function initMinis() {
  const { fetchInitialMiniCart, initMiniCartTouchHoverEvents, cleanUpMiniCartOnViewportResize } = initMiniCart();
  const { initMiniAccountTouchHoverEvents, cleanUpMiniAccountOnViewportResize } = initMiniAccount();
  const { fetchInitialMiniFavourites, initMiniFavouritesTouchHoverEvents, cleanUpMiniFavouritesOnViewportResize } =
    initMiniFavourites();

  Promise.allSettled([fetchInitialMiniFavourites(), fetchInitialMiniCart()]).then(() => {
    let currentIsXLargeUp = mediaQuery.isXLargeUp();
    window.addEventListener('resize', () => {
      const newIsXLargeUp = mediaQuery.isXLargeUp();
      if (currentIsXLargeUp !== newIsXLargeUp) {
        currentIsXLargeUp = newIsXLargeUp;
        initMiniCartTouchHoverEvents(currentIsXLargeUp);
        initMiniAccountTouchHoverEvents(currentIsXLargeUp);
        initMiniFavouritesTouchHoverEvents(currentIsXLargeUp);
        cleanUpMiniCartOnViewportResize();
        cleanUpMiniAccountOnViewportResize();
        cleanUpMiniFavouritesOnViewportResize();
      }
    });

    initMiniCartTouchHoverEvents(currentIsXLargeUp);
    initMiniAccountTouchHoverEvents(currentIsXLargeUp);
    initMiniFavouritesTouchHoverEvents(currentIsXLargeUp);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  cleanUpCheckoutStorageData();
  initNavigationEvents();
  cleanUpFinanceCalculatorStorageData();
  initMinis();

  const { isSearchSuggestionsEnabled } = window.bbGlobal.attraqt;
  if (isSearchSuggestionsEnabled) {
    const searchRootElement = document.getElementById('search-app');
    if (searchRootElement) {
      render(
        <MessagePropertiesProvider>
          <SearchApp />
        </MessagePropertiesProvider>,
        searchRootElement
      );
    }
  }

  const scrollToTopRootElement = document.getElementById('scroll-to-top');
  if (scrollToTopRootElement) {
    render(<ScrollToTop />, scrollToTopRootElement);
  }
});

(window as any).addToCartFormHandler = addToCartFormHandler;
